import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';

export function useAdWallet() {
  return useQuery({
    queryKey: ['adWallet'],
    queryFn: () => adsService.getWallet(),
  });
}
